<template>
  <div class="m-15">
    <picture-input
      ref="pictureInput"
      width="300"
      height="300"
      margin="16"
      accept="image/*"
      size="10"
      button-class="changeBtn"
      :prefill="prefillImage"
      :custom-strings="{
                        upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                        drag: 'Arraste uma imagem <br> (ou clique aqui)',
                        change: 'Mudar foto',
                      }"
      @change="onChange"
    />
  </div>
</template>

<script>
import PictureInput from "vue-picture-input";

export default {
  name: "inserirpromocaoimagem",
  components: {
    PictureInput
  },
  data: function () {
    return {
      prefillImage: []
    }
  },

  methods: {
    onChange(image) {
      if (image) {
        localStorage.setItem("image", image);
      }
    },

    getImage() {
      this.prefillImage = localStorage.getItem("image");
    }
  },
  beforeMount() {
    this.getImage();
    this.$emit("can-continue", { value: true });
  }
};
</script>